import { render, staticRenderFns } from "./VsPager.vue?vue&type=template&id=7128ce58&scoped=true&"
import script from "./VsPager.vue?vue&type=script&lang=js&"
export * from "./VsPager.vue?vue&type=script&lang=js&"
import style0 from "./VsPager.vue?vue&type=style&index=0&id=7128ce58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7128ce58",
  null
  
)

export default component.exports